/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AssignmentCircledIcon = /*#__PURE__*/ createSvgIcon(
  'AssignmentCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M5.75 15.5c-.344 0-.638-.122-.883-.367a1.204 1.204 0 01-.367-.883V5.5c0-.344.122-.638.367-.883s.54-.367.883-.367h2.625c.135-.375.362-.677.68-.906.317-.23.674-.344 1.07-.344s.753.115 1.07.344c.318.229.545.531.68.906H14.5c.344 0 .638.122.883.367s.367.54.367.883v8.75c0 .344-.122.638-.367.883a1.204 1.204 0 01-.883.367H5.75zm0-1.25h8.75V5.5H5.75v8.75zM7.625 13h3.125c.177 0 .325-.06.445-.18s.18-.268.18-.445a.605.605 0 00-.18-.445.605.605 0 00-.445-.18H7.625a.605.605 0 00-.445.18.605.605 0 00-.18.445c0 .177.06.325.18.445s.268.18.445.18zm0-2.5h5c.177 0 .325-.06.445-.18s.18-.268.18-.445a.605.605 0 00-.18-.445.605.605 0 00-.445-.18h-5a.605.605 0 00-.445.18.605.605 0 00-.18.445c0 .177.06.325.18.445s.268.18.445.18zm0-2.5h5c.177 0 .325-.06.445-.18s.18-.268.18-.445a.605.605 0 00-.18-.445.605.605 0 00-.445-.18h-5a.605.605 0 00-.445.18.605.605 0 00-.18.445c0 .177.06.326.18.445.12.12.268.18.445.18zm2.5-2.969a.455.455 0 00.469-.468.455.455 0 00-.469-.47.455.455 0 00-.469.47.455.455 0 00.469.468z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default AssignmentCircledIcon;
